export default function (state = {}, action) {
  switch (action.type) {
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/input.js